
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminos-condiciones",
      function () {
        return require("private-next-pages/terminos-condiciones/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminos-condiciones"])
      });
    }
  